/**
 * Рассчитывает скорость (км/ч) между двумя географическими точками по формуле Haversine.
 * Координаты передаются в формате 1e7 (целые числа).
 * @param {number} startLatitude - Широта начала (1e7).
 * @param {number} startLongitude - Долгота начала (1e7).
 * @param {string} startDate - Дата/время начала.
 * @param {number} finishLatitude - Широта конца (1e7).
 * @param {number} finishLongitude - Долгота конца (1e7).
 * @param {string} finishDate - Дата/время конца.
 * @returns {number|null} Скорость в км/ч или null, если разница времени равна 0.
 */
function calculateSpeed(startLatitude, startLongitude, startDate, finishLatitude, finishLongitude, finishDate) {
  // Преобразование даты и времени в миллисекунды
  // (возможно, вам потребуется использовать другой формат даты)
  const startTime = new Date(startDate).getTime();
  const finishTime = new Date(finishDate).getTime();

  // Расчет разницы во времени в секундах
  const timeDifferenceSeconds = Math.abs((finishTime - startTime) / 1000);
  // Проверка на нулевую разницу во времени
  if (timeDifferenceSeconds === 0) {
    return null;
  }

  const R = 6371000; // Радиус Земли в метрах

  const phi1 = (startLatitude / 1e7) * (Math.PI / 180); // Широта первой точки в радианах
  const lambda1 = (startLongitude / 1e7) * (Math.PI / 180); // Долгота первой точки в радианах
  const phi2 = (finishLatitude / 1e7) * (Math.PI / 180); // Широта второй точки в радианах
  const lambda2 = (finishLongitude / 1e7) * (Math.PI / 180); // Долгота второй точки в радианах

  const deltaPhi = phi2 - phi1; // Разница широт
  const deltaLambda = lambda2 - lambda1; // Разница долгот

  const a =
    Math.sin(deltaPhi / 2) * Math.sin(deltaPhi / 2) +
    Math.cos(phi1) * Math.cos(phi2) * Math.sin(deltaLambda / 2) * Math.sin(deltaLambda / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;

  // Расчет скорости в километрах в час
  return Math.round(distance / 1000 / (timeDifferenceSeconds / 3600));
  // Возвращаем скорость (возможно, вам потребуется отформатировать ее перед выводом)
}

export default calculateSpeed;
